import {get} from "axios";
import {withRouter} from "react-router-dom";
import React, {PureComponent} from "react";
import PhotoShell from "./PhotoShell";
import {WebpIsSupported} from "./imageSupport";

const applications = {
    PhotoShell: PhotoShell
}

//
// we adapt to what image formats are available on the client here:  this function rewrites the
//
// data.config.images
//
// to contain just one set of image files in the format that this function chooses.  Supported
// image formats are supplied in the array imageFormats in order of preference.
//

export const filterImages = (data, imageFormats) => {
    const { config, ...outerOther } = data
    const { images, ...other} = config
    const byFormat = {}
    for(const img of images) {
        const {name} = img
        const parts = name.split(".")
        const extension = parts[parts.length-1].toUpperCase()
        if (extension in byFormat) {
            byFormat[extension].push(img)
        } else {
            byFormat[extension] = [img]
        }

    }
    for(const format of imageFormats) {
        if(format in byFormat) {
            return {
                config: {images: byFormat[format], ...other},
                valid: true,
                ...outerOther
            }
        }
    }
    return { valid: false };
}

//
// ShellShell is a shell for a shell;  the enclosing App contains the react-router
// components that cause the pathname to be assigned to this component.  This
// component is wrapped in an HoC and then fetches the configuration for the
// application it contains (such as the PhotoShell) so that the application itself
// can be civilized;  at least to boot up it receives all of its configuration in
// a prop so it is nice and testable
//

class ShellShell extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
        }
    }

    componentDidMount = async () => {
        const { location } = this.props
        const { pathname } = location
        const imageFormat = await WebpIsSupported() ? ["WEBP", "JPG"] : ["JPG"]
        const response = await get(pathname+"DATA/CONFIG.JSON")
        this.setState({
            data: filterImages(response.data, imageFormat)
        })
    }

    render = () => {
        const { location } = this.props
        const { data } = this.state
        const { pathname, hash } = location

        if (!data) {
            return <div>Loading...</div>
        } else {
            const { application, config } = data
            const Application = applications[application]
            if (Application) {
                return <Application config={config} pathname={pathname} hash={hash}/>
            } else {
                return <div>Did not find a valid application</div>
            }
        }
    }
}

export default withRouter(ShellShell);
